import controller from './edit.controller';
import template from './edit.html';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.offices.edit', {
			controller,
			template,
			'url': '/edit/:id',
			'controllerAs': 'vm',
			'params': {
				'page': 1
			},
			'resolve': {
				'Office': function($state, $stateParams, OfficeComponent, Toast) {
					'ngInject';

					return OfficeComponent.fetchOffice($stateParams.id)
						.then(function(res) {
							if (res.data && res.data.errors) {
								Toast.responseError(res.data.errors);
								$state.go('app.private.offices.list');
							} else {
								return res;
							}
						});
				}
			}
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/offices/edit/edit.route.js
 **/